import { connect } from 'react-redux';

import DasherSlideshow from './dasher_slideshow.jsx';

import { getRenderAsMobile } from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state) => {
  const isMobile = getRenderAsMobile(state);

  return {
    isMobile,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DasherSlideshow);
